import baseApi from "@/api/baseApi";
export default {
  addOrUpdate(form) {
    return baseApi.post('/api-piglet/api/addition/v1', form);
  },
  fetchAll() {
    return baseApi.get('/api-piglet/api/addition/v1');
  },
  remove(id) {
    return baseApi.delete(`/api-piglet/api/addition/${id}/v1`);
  }
}
